import React, { useEffect, useRef } from 'react'
import { Box, Typography, Avatar } from '@material-ui/core'
import {
  Printer as PrintIcon,
  ExternalLink as ExternalLinkIcon,
  Archive as ArchiveIcon,
  Trash2 as TrashIcon,
  Clock as ClockIcon,
  Tag as LabelIcon,
  MoreVertical as MoreIcon,
  ArrowLeft as ArrowLeftIcon,
  ChevronRight as ChevronRightIcon,
  Star as StarIcon,
  MoreHorizontal as MoreHorizIcon,
} from 'react-feather'

import useAuth from 'hooks/useAuth'
import EmailSideBar from '../EmailSideBar'
import useStyles from './styles'

const EmailActionBar = ({ classes }) => (
  <Box className={classes.emailActionBar}>
    <Box className={classes.emailActionBarLeft}>
      <ArrowLeftIcon size={16} className={classes.emailActionIcon} />
      <ArchiveIcon size={16} className={classes.emailActionIcon} />
      <TrashIcon size={16} className={classes.emailActionIcon} />
      <LabelIcon size={16} className={classes.emailActionIcon} />
      <ClockIcon size={16} className={classes.emailActionIcon} />
      <MoreIcon size={16} className={classes.emailActionIcon} />
    </Box>
    <Box className={classes.emailActionBarRight}>
      <Typography className={classes.emailPagination}>1–50 de 2.619</Typography>
      <ChevronRightIcon size={16} className={classes.emailActionIcon} />
    </Box>
  </Box>
)

const EmailHeader = ({ template, user, classes }) => {
  const senderName = template.fromName || user?.name || ''
  const senderEmail = user?.email || ''
  const initials = senderName
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0].toUpperCase())
    .join('')

  return (
    <Box className={classes.emailHeader}>
      <Box className={classes.emailSubjectRow}>
        <Typography className={classes.emailSubject}>
          {template.emailSubject || 'Sem assunto'}
        </Typography>
        <Box className={classes.emailSubjectTags}>
          <Box className={classes.emailTag}>Caixa de entrada</Box>
        </Box>
        <Box className={classes.emailHeaderIcons}>
          <PrintIcon size={16} className={classes.emailActionIcon} />
          <ExternalLinkIcon size={16} className={classes.emailActionIcon} />
        </Box>
      </Box>

      <Box className={classes.emailSenderRow}>
        <Avatar className={classes.emailAvatar}>{initials}</Avatar>
        <Box className={classes.emailSenderInfo}>
          <Box className={classes.emailSenderNameRow}>
            <Typography className={classes.emailSenderName}>
              {senderName}
            </Typography>
            <Typography className={classes.emailSenderAddress}>
              &lt;{senderEmail}&gt;
            </Typography>
            <Typography className={classes.emailSenderUnsub}>
              Desinscrever-se
            </Typography>
          </Box>
          <Typography className={classes.emailSenderTo}>para mim ▾</Typography>
        </Box>
        <Box className={classes.emailSenderActions}>
          <Typography className={classes.emailTime}>
            09:14 (8 horas atrás)
          </Typography>
          <StarIcon size={16} className={classes.emailActionIcon} />
          <MoreHorizIcon size={16} className={classes.emailActionIcon} />
        </Box>
      </Box>
    </Box>
  )
}

const EmailBodyIframe = ({ html, subject, classes }) => {
  const iframeRef = useRef(null)

  useEffect(() => {
    const iframe = iframeRef.current
    if (!iframe || !html) return
    const doc = iframe.contentDocument || iframe.contentWindow?.document
    if (!doc) return
    const sanitized = html.replace(/<script[\s\S]*?<\/script>/gi, '')
    doc.open()
    doc.write(sanitized)
    doc.close()

    requestAnimationFrame(() => {
      const height = doc.documentElement?.scrollHeight || doc.body?.scrollHeight
      if (height && iframe) iframe.style.height = `${height}px`
    })
  }, [html])

  if (!html) {
    return (
      <Box className={classes.emailBodyPlaceholder}>
        <Typography variant="body2" color="textSecondary">
          Sem conteúdo de e-mail disponível.
        </Typography>
      </Box>
    )
  }

  return (
    <iframe
      ref={iframeRef}
      title={`E-mail: ${subject}`}
      className={classes.emailBodyIframe}
    />
  )
}

const EmailView = ({ template }) => {
  const classes = useStyles()
  const { user } = useAuth()

  return (
    <Box className={classes.emailView}>
      <Box className={classes.gmailBar}>
        <Box className={classes.gmailHamburger}>
          <Box className={classes.gmailHamburgerLine} />
          <Box className={classes.gmailHamburgerLine} />
          <Box className={classes.gmailHamburgerLine} />
        </Box>
        <Typography className={classes.gmailLogo}>Gmail</Typography>
        <Box className={classes.gmailSearch}>
          <Typography className={classes.gmailSearchText}>Buscar</Typography>
        </Box>
      </Box>
      <Box className={classes.gmailContent}>
        <EmailSideBar />
        <Box className={classes.gmailMain}>
          <EmailActionBar classes={classes} />

          <Box className={classes.emailThread}>
            <EmailHeader template={template} user={user} classes={classes} />

            <Box className={classes.emailBody}>
              <Box className={classes.emailBodyOverlay} />
              <EmailBodyIframe
                html={template.emailHtmlBody}
                subject={template.emailSubject}
                classes={classes}
              />
            </Box>

            <Box className={classes.emailReplyBar}>
              <Box className={classes.emailReplyBtn}>
                <Typography className={classes.emailReplyBtnText}>
                  ↩ Responder
                </Typography>
              </Box>
              <Box className={classes.emailReplyBtn}>
                <Typography className={classes.emailReplyBtnText}>
                  ↪ Encaminhar
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default EmailView
